const MAPS_API_KEY = 'AIzaSyArGBDD37bVoDXvdZx_CH0ecnE1B83MgdI';
export default MAPS_API_KEY;

export const userTypes = {
  admin: 'admin',
  supplier: 'supplier',
  manager: 'manager',
  creative: 'creative',
  buyer: 'buyer',
};
